// extracted by mini-css-extract-plugin
export default {"content":"AuthLayout_content__cyJtY"};